var map = {
	"./icon-cigarette-original.svg": 1641,
	"./icon-cigarette.svg": 157,
	"./icon-cinema-original.svg": 1642,
	"./icon-cinema.svg": 158,
	"./icon-magnifying-glass-green.svg": 636,
	"./icon-magnifying-glass.svg": 1643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1640;